<template>
  <div>
    <c-tab
      type="horizon"
      :dense="true"
      :inlineLabel="true"
      :tabItems.sync="tabItems"
      :height="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :popupParam="popupParam"
          :contentHeight="contentHeight"
          @deleteAssess="deleteAssess"
          @setRegInfo="setRegInfo"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'vendor-assess-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmVendorEvaluationId: '',
        vendorCd: '',
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      editable: true,
      tab: 'vendorAssessInfo',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 36);
    },
    tabItems() {
      let items = [
        { name: 'vendorAssessInfo', icon: 'edit', label: '평가정보', component: () => import(`${'./vendorAssessInfo.vue'}`) },
      ];
      if (this.popupParam.mdmVendorEvaluationId) {
        items.push({ name: 'vendorAssessHistory', icon: 'history', label: '평가이력', component: () => import(`${'./vendorAssessHistory.vue'}`) })
      }
      return items;
    }
  },
  methods: {
    init() {
    },
    deleteAssess() {
      this.$emit('closePopup');
    },
    setRegInfo(data) {
      this.$emit('setRegInfo', data)
    }
  }
};
</script>
